{
    "I9eo-Xpq4Oq78lJStDBs0": {
        "key": "I9eo-Xpq4Oq78lJStDBs0",
        "position": {
            "x": 3,
            "y": 4,
            "z": 1
        },
        "affiliation": "good",
        "type": "zone"
    },
    "3PJGtJ5bEZvk0tBwlB2wk": {
        "key": "3PJGtJ5bEZvk0tBwlB2wk",
        "position": {
            "x": 4,
            "y": 4,
            "z": 1
        },
        "affiliation": "good",
        "type": "zone"
    },
    "q3ODhAgMGCBMe3wkYqamH": {
        "key": "q3ODhAgMGCBMe3wkYqamH",
        "position": {
            "x": 3,
            "y": 5,
            "z": 1
        },
        "affiliation": "good",
        "type": "zone"
    },
    "saul": {
        "key": "saul",
        "position": {
            "x": 3,
            "y": 2,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/cleric"
    },
    "#B": {
        "key": "#B",
        "position": {
            "x": 1,
            "y": 4,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/berserker"
    },
    "#C": {
        "key": "#C",
        "position": {
            "x": 5,
            "y": 3,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/berserker"
    },
    "#D": {
        "key": "#D",
        "position": {
            "x": 0,
            "y": 1,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/archer"
    }
}